import { ThreeDot } from "react-loading-indicators";

export default function Loader() {
  return (
    <div className="flex justify-center items-center py-10">
      <ThreeDot color="#4d7c0f" size="small" text="" textColor="" />
    </div>
  );
}
